import { ACTIVE_EXPERIMENT, SUPPORTED_EXPERIMENTS, EXPERIMENT_BY_HEADER } from 'config/experiments';
import { Experiments } from 'types/Experiments';

export const parseExperiments = (
  headerValue: string,
  isAppUser: boolean,
  supportedExperiments = SUPPORTED_EXPERIMENTS,
): Experiments => {
  if (!headerValue) return {};

  try {
    const parsed = JSON.parse(headerValue);

    return Object.fromEntries(
      Object.entries(parsed)
        .filter(([headerId]) => supportedExperiments.has(headerId))
        .map(([headerId, value]) => {
          const experimentConfig = EXPERIMENT_BY_HEADER[headerId];
          const isChallenger = value === 'challenger' || value === 'b';
          if (isAppUser && experimentConfig?.excludeApp) {
            return [headerId, false];
          }
          return [headerId, isChallenger];
        }),
    );
  } catch {
    return {};
  }
};

export const isPreviewingExperiment = (experiments?: Experiments, activeExperiment = ACTIVE_EXPERIMENT): boolean =>
  typeof experiments === 'object' &&
  Object.entries(experiments).some(([id, value]) => id !== activeExperiment && value);

export const isInActiveChallengerGroup = (experiments?: Experiments, activeExperiment = ACTIVE_EXPERIMENT): boolean =>
  !!(typeof experiments === 'object' && experiments[`${activeExperiment}`]);

/**
 * Determines if the insurance redesign (SE-20) should be enabled.
 * For 'very' brand, it's always enabled.
 * For other brands, it's enabled only when the se-20 experiment is active.
 */
export const isInsuranceRedesignEnabled = (site: string, experiments?: Experiments): boolean =>
  site === 'very' || !!experiments?.['se-20'];
